// Accordion functionality for Resources page
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".accordion__item");

  items.forEach((item) => {
    const header = item.querySelector(".accordion__item--header");
    const content = item.querySelector(".accordion__item--content");

    if (!header || !content) return;

    // Use max-height animation (from SCSS) but compute the real height dynamically.
    // This prevents FAQ answers from being clipped by the previous fixed value.
    item.classList.remove("active");
    header.setAttribute("aria-expanded", "false");
    content.style.display = "block"; // needed so scrollHeight is measurable
    content.style.maxHeight = "0px";

    header.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      // Close all other accordion items
      items.forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains("active")) {
          otherItem.classList.remove("active");
          const otherHeader = otherItem.querySelector(".accordion__item--header");
          const otherContent = otherItem.querySelector(".accordion__item--content");
          if (otherHeader) otherHeader.setAttribute("aria-expanded", "false");
          if (otherContent) otherContent.style.maxHeight = "0px";
        }
      });

      // Toggle the clicked item
      if (isActive) {
        item.classList.remove("active");
        header.setAttribute("aria-expanded", "false");
        content.style.maxHeight = "0px";
        return;
      }

      item.classList.add("active");
      header.setAttribute("aria-expanded", "true");
      // Defer to next frame so layout is up-to-date when items were revealed.
      requestAnimationFrame(() => {
        content.style.maxHeight = `${content.scrollHeight}px`;
      });
    });
  });
});
